import { $t } from "@/plugins/i18n";
import { tableView } from "@/router/enums";

const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/wb-teacher-calendar",
    component: Layout,
    redirect: "/wb-teacher/classroom-calendar",
    meta: {
      icon: "ic/outline-calendar-month",
      title: $t("wb.menu.myCalendar"),
      rank: tableView + 6
    },
    children: [
      {
        path: "/wb-teacher/classroom-calendar",
        name: "WbTeacherClassroomCalendar",
        component: () =>
          import("@/views/wb-teacher/classroom-calendar/index.vue"),
        meta: {
          title: $t("wb.menu.myCalendar"),
          icon: "ic/outline-calendar-month",
          keepAlive: true,
          roles: ["teacher"]
        }
      }
    ]
  },
  {
    path: "/wb-teacher-lessons",
    component: Layout,
    redirect: "/wb-teacher/lesson-list",
    meta: {
      icon: "ic/outline-menu-book",
      title: $t("wb.menu.myLessons"),
      rank: tableView + 7
    },
    children: [
      {
        path: "/wb-teacher/lesson-list",
        name: "WbTeacherLessonList",
        component: () => import("@/views/wb-teacher/lesson-list/index.vue"),
        meta: {
          title: $t("wb.menu.myLessons"),
          icon: "ic/outline-menu-book",
          keepAlive: true,
          roles: ["teacher"]
        }
      }
    ]
  },
  {
    path: "/wb-teacher-hidden",
    component: Layout,
    meta: {
      title: $t("menus.pureEmpty"),
      showLink: false
    },
    children: [
      {
        path: "/wb-teacher/classroom-detail/:classroom_id(.*)",
        name: "WbTeacherClassroomDetail",
        component: () =>
          import("@/views/wb-teacher/classroom-detail/index.vue"),
        meta: {
          title: $t("wb.menu.myClassroom"),
          icon: "ri/group-3-fill",
          showLink: false,
          keepAlive: true,
          roles: ["teacher"]
        }
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
